import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';

interface Props {
  confirmationMessage?: string;
}

function CsvUploadSuccess({ confirmationMessage = 'Upload Successful!' }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CheckCircleRoundedIcon className={classes.icon} titleAccess="Success Icon" />
      <Typography variant="h6">{confirmationMessage}</Typography>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 'auto',
  },
  icon: {
    color: theme.palette.success.main,
    minHeight: 141,
    minWidth: 141,
    marginBottom: theme.spacing(3),
  },
}));

export default CsvUploadSuccess;
